import { Injectable } from '@angular/core';
import { onMessage } from 'firebase/messaging';
import { FirebaseService } from './firebase.service';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationListenerService {
  constructor(
    private firebaseService: FirebaseService,
    private messageService: MessageService
  ) {
    this.listenForMessages();
  }

  listenForMessages() {
    onMessage(this.firebaseService.fire_messaging, payload => {
      console.log('Foreground push received:', payload);
      // this.messageService.add({
      //   severity: 'success',
      //   detail: `Notification: ${payload.notification?.title} - ${payload.notification?.body}`,
      // });
      this.messageService.add({
        key: 'orgToast',
        // sticky: true,
        severity: 'notification-toast',
        summary: 'Notification',
        detail: `Notification: ${payload.notification?.title} - ${payload.notification?.body}`,
      });
    });
  }
}
